export const ID_EL_GORDO = 1
export const ID_EURO_MILLIONS = 2
export const ID_POWERBALL = 3
export const ID_MEGASENA = 4
export const ID_NATIONAL = 5
export const ID_UK_LOTTO = 7
export const ID_THUNDERBALL = 8
export const ID_MEGA_MILLIONS = 9
export const ID_LOTTO_AMERICA = 10
export const ID_NATIONAL_THURSDAY = 6
export const ID_QUINA = 11
export const ID_LOTTO_FACIL = 12
export const ID_EL_GORDO_NAVIDAD = 13
export const ID_EURODREAMS_PT = 15
export const ID_EURODREAMS_FR = 16
export const ID_LOTO_FR = 17
export const ID_KENO_FR = 18
// const ID_SANTA_CASA = 6
